import { render, staticRenderFns } from "./addtestscope.vue?vue&type=template&id=546d17a8&scoped=true"
import script from "./addtestscope.vue?vue&type=script&lang=js"
export * from "./addtestscope.vue?vue&type=script&lang=js"
import style0 from "./addtestscope.vue?vue&type=style&index=0&id=546d17a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d17a8",
  null
  
)

export default component.exports